import { render, staticRenderFns } from "./ContainerGenderCard.vue?vue&type=template&id=545b1033&scoped=true"
import script from "./ContainerGenderCard.vue?vue&type=script&lang=js"
export * from "./ContainerGenderCard.vue?vue&type=script&lang=js"
import style0 from "./ContainerGenderCard.vue?vue&type=style&index=0&id=545b1033&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b1033",
  null
  
)

export default component.exports